import store from '@/core/store'
import {actionTypes} from '@/core/constants'

class BuscarDominioPerfilUsuarioListener {
    async execute() {
        try {
            const usuarioId = store.state?.loki?.user?.id
            const perfilTipo = store.state?.loki?.user?.type

            const dominios = await store.dispatch(actionTypes.BUSCAR_DOMINIO_PERFIL_USUARIO, {usuarioId, perfilTipo})

            if (this.ehComprador(perfilTipo)) {
                const domainType = store.state?.loki?.user?.domainType
                const domainId = store.state?.loki?.user?.domainId
                const perfis = store.state?.perfis || []
                let perfilCliente = null

                if (domainId === null || domainId === undefined || domainId === 0) {
                    perfilCliente = perfis[0] || null
                } else {
                    perfilCliente = perfis.find((perfil) => perfil.chaveCliente === domainId && perfil.tipoCliente === domainType) || null
                }

                if (perfilCliente && perfilCliente.chaveCliente && perfilCliente.tipoCliente) {
                    const dominio = {
                        dominioClienteId: perfilCliente.chaveCliente,
                        dominioTipo: perfilCliente.tipoCliente
                    }
                    await store.dispatch(actionTypes.ATUALIZAR_SESSAO_DOMINIO, dominio)
                }
            }
            return dominios
        } catch (e) {
            const status = e && e.response && e.response.status
            if (status === 401 || status === 403) {
                return
            }
            throw e
        }
    }

    ehComprador(perfilTipo) {
        return perfilTipo === 'INTERNO'
    }
}

export default new BuscarDominioPerfilUsuarioListener()
